webpackJsonp([127212392247514],{

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _infoBlock = __webpack_require__(10);
	
	var _infoBlock2 = _interopRequireDefault(_infoBlock);
	
	var _angleBracketButton = __webpack_require__(13);
	
	var _angleBracketButton2 = _interopRequireDefault(_angleBracketButton);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _Fade = __webpack_require__(69);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _gatsbyLink = __webpack_require__(31);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _info = __webpack_require__(281);
	
	var _info2 = _interopRequireDefault(_info);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationChoice = function (_Component) {
	  _inherits(ApplicationChoice, _Component);
	
	  function ApplicationChoice() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ApplicationChoice);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      showInfo: false
	    }, _this.toggleInfo = function () {
	      return _this.setState(function (_ref) {
	        var showInfo = _ref.showInfo;
	        return { showInfo: !showInfo };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ApplicationChoice.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _mediaQueries.Default,
	        null,
	        _react2.default.createElement(DefaultApplicationChoice, _extends({}, this.props, this.state, {
	          toggleInfo: this.toggleInfo
	        }))
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Mobile,
	        null,
	        _react2.default.createElement(MobileApplicationChoice, _extends({}, this.props, this.state, {
	          toggleInfo: this.toggleInfo
	        }))
	      )
	    );
	  };
	
	  return ApplicationChoice;
	}(_react.Component);
	
	exports.default = ApplicationChoice;
	
	
	var DefaultApplicationChoice = function DefaultApplicationChoice(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        display: 'flex'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#F7F7F7',
	          minHeight: props.height,
	          padding: (0, _mediaQueries.isTablet)() ? '2rem 4rem 3rem' : '2rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '5rem' : '7rem') + ' 2rem 5rem',
	          width: '58vw'
	        }
	      },
	      _react2.default.createElement(_infoBlock2.default, {
	        title: props.title,
	        bigTitle: true,
	        extra: props.titleAccent,
	        accentColor: '#8CBD8C',
	        text: props.text
	      }),
	      _react2.default.createElement(
	        _Fade2.default,
	        { when: props.showInfo, collapse: true },
	        _react2.default.createElement(_infoBlock2.default, {
	          title: props.doubleDegreeTitle,
	          text: props.doubleDegreeText
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#8CBD8C',
	          minHeight: props.height,
	          padding: '15vh ' + ((0, _mediaQueries.isNarrowDesktop)() ? '8vw' : '12.5vw') + ' 1rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '1rem' : '3rem'),
	          width: '42vw'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: '3rem' } },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              color: 'white',
	              fontSize: 20,
	              fontWeight: 700,
	              marginBottom: '.5rem'
	            }
	          },
	          'First question:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { fontWeight: 600, fontSize: 14 } },
	          props.stepText
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        props.tracks.map(function (_ref2) {
	          var name = _ref2.trackName;
	          return _react2.default.createElement(_angleBracketButton2.default, {
	            key: name,
	            text: name,
	            onClick: function onClick() {
	              return props.setChoice(name);
	            },
	            style: { marginBottom: '.5rem' }
	          });
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            margin: '3rem 0',
	            fontStyle: 'italic',
	            fontSize: 12
	          }
	        },
	        props.explanationDegrees
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'right' } },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              fontSize: 14,
	              fontWeight: 600,
	              cursor: 'pointer',
	              display: 'flex',
	              justifyContent: 'flex-end',
	              alignItems: 'center'
	            },
	            onClick: props.toggleInfo
	          },
	          'Our programmes\xA0\xA0',
	          _react2.default.createElement(_info2.default, {
	            style: { width: '1rem', height: '1rem' },
	            color: '#8CBD8C'
	          })
	        )
	      )
	    )
	  );
	};
	
	var MobileApplicationChoice = function MobileApplicationChoice(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: '#8CBD8C'
	      }
	    },
	    _react2.default.createElement(_infoBlock2.default, {
	      title: props.title,
	      extra: props.titleAccent,
	      text: props.text,
	      style: { padding: '1rem 2rem 1rem' }
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '0 3rem 0', paddingBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            color: 'white',
	            fontSize: 20,
	            fontWeight: 700,
	            marginBottom: '.5rem'
	          }
	        },
	        'First question:'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontWeight: 600, fontSize: 14 } },
	        props.stepText
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '1rem 2rem' } },
	      props.tracks.map(function (_ref3) {
	        var name = _ref3.trackName;
	        return _react2.default.createElement(_angleBracketButton2.default, {
	          key: name,
	          text: name,
	          onClick: function onClick() {
	            return props.setChoice(name);
	          },
	          style: { marginBottom: '.5rem' }
	        });
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '1rem 3rem',
	          fontStyle: 'italic',
	          fontSize: '12px'
	        }
	      },
	      props.explanationDegrees
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          textAlign: 'right',
	          marginRight: '3rem',
	          paddingBottom: '3rem'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            fontSize: 14,
	            fontWeight: 600,
	            cursor: 'pointer'
	          }
	        },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/programme#double-degree' },
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                display: 'flex',
	                justifyContent: 'flex-end',
	                alignItems: 'center'
	              }
	            },
	            'Our programme\xA0\xA0',
	            _react2.default.createElement(_info2.default, {
	              style: { width: '1rem', height: '1rem' },
	              color: '#8CBD8C'
	            })
	          )
	        )
	      )
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _infoBlock = __webpack_require__(10);
	
	var _infoBlock2 = _interopRequireDefault(_infoBlock);
	
	var _angleBracketButton = __webpack_require__(13);
	
	var _angleBracketButton2 = _interopRequireDefault(_angleBracketButton);
	
	var _collapsableCard = __webpack_require__(107);
	
	var _collapsableCard2 = _interopRequireDefault(_collapsableCard);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _Fade = __webpack_require__(69);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _step = __webpack_require__(104);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _angleBracket = __webpack_require__(29);
	
	var _angleBracket2 = _interopRequireDefault(_angleBracket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationKnowledge = function (_Component) {
	  _inherits(ApplicationKnowledge, _Component);
	
	  function ApplicationKnowledge() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ApplicationKnowledge);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      infoText: '',
	      selected: {}
	    }, _this.showInfo = function (target) {
	      return _this.setState(function (prevState) {
	        var _extends2;
	
	        return {
	          infoText: target,
	          selected: _extends({}, prevState.selected, (_extends2 = {}, _extends2[target] = undefined, _extends2))
	        };
	      });
	    }, _this.conditionalContinue = function () {
	      if (Object.keys(_this.state.selected).length === 3) {
	        _this.props.nextStep();
	      }
	    }, _this.buttonProps = function (target) {
	      return {
	        style: {
	          border: Object.keys(_this.state.selected).indexOf(target) !== -1 && '3px solid white',
	          background: Object.keys(_this.state.selected).indexOf(target) !== -1 ? 'none' : 'white'
	        },
	        textStyle: {
	          color: Object.keys(_this.state.selected).indexOf(target) !== -1 ? 'white' : 'black'
	        },
	        hasCaret: Object.keys(_this.state.selected).indexOf(target) === -1,
	        hasShadow: Object.keys(_this.state.selected).indexOf(target) === -1
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ApplicationKnowledge.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _mediaQueries.Default,
	        null,
	        _react2.default.createElement(DefaultApplicationKnowledge, _extends({}, this.props, this.state, {
	          legalisationsButtonProps: this.buttonProps('legalisations'),
	          tuitionAndScholarshipsButtonProps: this.buttonProps('tuitionAndScholarships'),
	          contactButtonProps: this.buttonProps('contact'),
	          conditionalContinue: this.conditionalContinue,
	          showInfo: this.showInfo
	        }))
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Mobile,
	        null,
	        _react2.default.createElement(MobileApplicationKnowledge, _extends({}, this.props, this.state, {
	          conditionalContinue: this.conditionalContinue,
	          setSelected: function setSelected(target) {
	            return _this2.setState(function (prevState) {
	              var _extends3;
	
	              return {
	                selected: _extends({}, prevState.selected, (_extends3 = {}, _extends3[target] = undefined, _extends3))
	              };
	            });
	          }
	        }))
	      )
	    );
	  };
	
	  return ApplicationKnowledge;
	}(_react.Component);
	
	exports.default = ApplicationKnowledge;
	
	
	var DefaultApplicationKnowledge = function DefaultApplicationKnowledge(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        display: 'flex'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#F7F7F7',
	          minHeight: props.height,
	          padding: (0, _mediaQueries.isTablet)() ? '2rem 4rem 3rem' : '2rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '5rem' : '7rem') + ' 2rem 5rem',
	          width: '58vw'
	        }
	      },
	      _react2.default.createElement(_infoBlock2.default, {
	        title: props.header.title,
	        bigTitle: true,
	        extra: props.header.titleAccent,
	        accentColor: '#8CBD8C',
	        text: props.header.text.internal.content
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            position: 'relative'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              position: 'absolute'
	            }
	          },
	          _react2.default.createElement(
	            _Fade2.default,
	            { when: props.infoText === 'legalisations', collapse: true },
	            _react2.default.createElement(_infoBlock2.default, {
	              title: props.legalisations,
	              text: props.legalisationsText.internal.content
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              position: 'absolute'
	            }
	          },
	          _react2.default.createElement(
	            _Fade2.default,
	            { when: props.infoText === 'tuitionAndScholarships', collapse: true },
	            _react2.default.createElement(_infoBlock2.default, {
	              title: props.tuitionAndScholarships,
	              text: props.tuitionAndScholarshipsText.internal.content
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              position: 'absolute'
	            }
	          },
	          _react2.default.createElement(
	            _Fade2.default,
	            { when: props.infoText === 'contact', collapse: true },
	            _react2.default.createElement(_infoBlock2.default, {
	              title: props.contact,
	              text: props.contactText.internal.content
	            })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(SideContent, props)
	  );
	};
	
	var MobileApplicationKnowledge = function MobileApplicationKnowledge(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: 'white'
	      }
	    },
	    _react2.default.createElement(_infoBlock2.default, {
	      title: props.header.title,
	      extra: props.header.titleAccent,
	      accentColor: '#8CBD8C',
	      text: props.header.text.internal.content,
	      style: { padding: '1rem 2rem' }
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '0 3rem', paddingBottom: '1rem' } },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            color: 'white',
	            fontSize: 20,
	            fontWeight: 700,
	            marginBottom: '.5rem'
	          }
	        },
	        _react2.default.createElement(_step2.default, _extends({}, props.step, {
	          accentColor: '#8CBD8C',
	          style: { color: 'black' }
	        }))
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '1rem 2rem' } },
	      _react2.default.createElement(_collapsableCard2.default, {
	        title: props.legalisations,
	        text: props.legalisationsText.internal.content,
	        className: 'card',
	        style: { background: '#F7F7F7', marginBottom: '0.5rem' },
	        onClick: function onClick() {
	          return props.setSelected('legalisations');
	        }
	      }),
	      _react2.default.createElement(_collapsableCard2.default, {
	        title: props.tuitionAndScholarships,
	        text: props.tuitionAndScholarshipsText.internal.content,
	        className: 'card',
	        style: { background: '#F7F7F7', marginBottom: '0.5rem' },
	        onClick: function onClick() {
	          return props.setSelected('tuitionAndScholarships');
	        }
	      }),
	      _react2.default.createElement(_collapsableCard2.default, {
	        title: props.contact,
	        text: props.contactText.internal.content,
	        className: 'card',
	        style: { background: '#F7F7F7', marginBottom: '0.5rem' },
	        onClick: function onClick() {
	          return props.setSelected('contact');
	        }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '1rem 3rem',
	          fontStyle: 'italic',
	          fontSize: '12px'
	        }
	      },
	      props.explanationDegrees
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '2rem 2rem',
	          border: '3px solid ' + (Object.keys(props.selected).length === 3 ? '#8CBD8C' : '#f7f7f7'),
	          padding: '1.5em',
	          textAlign: 'center',
	          color: Object.keys(props.selected).length === 3 ? 'black' : '#f7f7f7',
	          fontSize: 18,
	          fontWeight: 600,
	          background: Object.keys(props.selected).length === 3 ? '#8CBD8C' : '',
	          cursor: Object.keys(props.selected).length === 3 ? 'pointer' : ''
	        },
	        className: 'unselectable ' + (Object.keys(props.selected).length === 3 ? 'card' : ''),
	        onClick: props.conditionalContinue
	      },
	      props.applicationProcedure
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '1rem 3rem',
	          fontStyle: 'italic',
	          fontSize: 12
	        }
	      },
	      props.closingText
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          padding: '2rem 2rem 3rem',
	          fontSize: 14,
	          fontWeight: 600,
	          display: 'flex',
	          justifyContent: 'flex-start',
	          alignItems: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.previousStep, style: { cursor: 'pointer' } },
	        _react2.default.createElement(_angleBracket2.default, {
	          color: 'black',
	          style: {
	            width: 5,
	            transform: 'scaleX(-1)',
	            filter: 'FlipH'
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA0\xA0Back'
	        )
	      )
	    )
	  );
	};
	
	var SideContent = function SideContent(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: '#8CBD8C',
	        minHeight: props.height,
	        padding: '15vh ' + ((0, _mediaQueries.isNarrowDesktop)() ? '8vw' : '12.5vw') + ' 1rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '1rem' : '3rem'),
	        width: '42vw'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '3rem' } },
	      _react2.default.createElement(_step2.default, props.step)
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_angleBracketButton2.default, _extends({
	        caretPosition: 'left',
	        caretDirection: 'left',
	        onClick: function onClick() {
	          return props.showInfo('legalisations');
	        },
	        text: props.legalisations
	      }, props.legalisationsButtonProps, {
	        style: _extends({
	          marginTop: Object.keys(props.selected).indexOf('legalisations') !== -1 ? -6 : 0
	        }, props.legalisationsButtonProps.style)
	      })),
	      _react2.default.createElement(_angleBracketButton2.default, _extends({
	        caretPosition: 'left'
	      }, props.tuitionAndScholarshipsButtonProps, {
	        style: _extends({
	          marginBottom: Object.keys(props.selected).indexOf('tuitionAndScholarships') !== -1 ? ' calc(.5rem - 3px)' : '.5rem',
	          marginTop: Object.keys(props.selected).indexOf('tuitionAndScholarships') !== -1 ? ' calc(.5rem - 3px)' : '.5rem'
	        }, props.tuitionAndScholarshipsButtonProps.style),
	        caretDirection: 'left',
	        onClick: function onClick() {
	          return props.showInfo('tuitionAndScholarships');
	        },
	        text: props.tuitionAndScholarships
	      })),
	      _react2.default.createElement(_angleBracketButton2.default, _extends({
	        caretPosition: 'left',
	        caretDirection: 'left',
	        onClick: function onClick() {
	          return props.showInfo('contact');
	        },
	        text: props.contact
	      }, props.contactButtonProps, {
	        style: _extends({
	          marginBottom: Object.keys(props.selected).indexOf('contact') !== -1 ? -6 : 0
	        }, props.contactButtonProps.style)
	      })),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginTop: '3rem',
	            border: '3px solid white',
	            padding: '1.5em',
	            textAlign: 'center',
	            color: Object.keys(props.selected).length === 3 ? 'black' : 'white',
	            fontSize: 18,
	            fontWeight: 600,
	            background: Object.keys(props.selected).length === 3 ? 'white' : 'none',
	            cursor: Object.keys(props.selected).length === 3 ? 'pointer' : ''
	          },
	          className: 'unselectable ' + (Object.keys(props.selected).length === 3 ? 'card' : ''),
	          onClick: props.conditionalContinue
	        },
	        props.applicationProcedure
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '2rem 0 3rem',
	          fontStyle: 'italic',
	          fontSize: 12
	        }
	      },
	      props.closingText
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          fontSize: 14,
	          fontWeight: 600,
	          display: 'flex',
	          justifyContent: 'flex-start',
	          alignItems: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.previousStep, style: { cursor: 'pointer' } },
	        _react2.default.createElement(_angleBracket2.default, {
	          color: 'black',
	          style: {
	            width: 5,
	            transform: 'scaleX(-1)',
	            filter: 'FlipH'
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA0\xA0Back'
	        )
	      )
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _infoBlock = __webpack_require__(10);
	
	var _infoBlock2 = _interopRequireDefault(_infoBlock);
	
	var _angleBracket = __webpack_require__(29);
	
	var _angleBracket2 = _interopRequireDefault(_angleBracket);
	
	var _step = __webpack_require__(104);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _angleBracketButton = __webpack_require__(13);
	
	var _angleBracketButton2 = _interopRequireDefault(_angleBracketButton);
	
	var _collapsable = __webpack_require__(39);
	
	var _collapsable2 = _interopRequireDefault(_collapsable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationProcedure = function (_Component) {
	  _inherits(ApplicationProcedure, _Component);
	
	  function ApplicationProcedure() {
	    _classCallCheck(this, ApplicationProcedure);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ApplicationProcedure.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _mediaQueries.Default,
	        null,
	        _react2.default.createElement(DefaultApplicationProcedure, this.props)
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Mobile,
	        null,
	        _react2.default.createElement(MobileApplicationProcedure, this.props)
	      )
	    );
	  };
	
	  return ApplicationProcedure;
	}(_react.Component);
	
	exports.default = ApplicationProcedure;
	
	
	var DefaultApplicationProcedure = function DefaultApplicationProcedure(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        display: 'flex'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#F7F7F7',
	          minHeight: props.height,
	          padding: (0, _mediaQueries.isTablet)() ? '2rem 4rem 3rem' : '2rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '5rem' : '7rem') + ' 2rem 5rem',
	          width: '58vw'
	        }
	      },
	      _react2.default.createElement(_infoBlock2.default, {
	        title: props.header.title,
	        bigTitle: true,
	        extra: props.header.titleAccent,
	        accentColor: '#8CBD8C',
	        text: props.header.text.internal.content
	      })
	    ),
	    _react2.default.createElement(SideContent, props)
	  );
	};
	
	var MobileApplicationProcedure = function MobileApplicationProcedure(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: '#8CBD8C'
	      }
	    },
	    _react2.default.createElement(_infoBlock2.default, {
	      title: props.header.title,
	      extra: props.header.titleAccent,
	      text: props.header.text.internal.content,
	      style: { padding: '1rem 2rem' }
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '0 3rem', paddingBottom: '1rem' } },
	      _react2.default.createElement(_step2.default, props.step)
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '1rem 2rem' } },
	      _react2.default.createElement(_angleBracketButton2.default, {
	        text: props.eConsortLink.displayName,
	        newTab: true,
	        link: props.eConsortLink.url
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            margin: '1rem',
	            fontStyle: 'italic',
	            fontSize: 12
	          }
	        },
	        props.registrationText
	      ),
	      _react2.default.createElement(
	        _collapsable2.default,
	        {
	          isCollapsed: true,
	          text: props.registeredButtonText,
	          backgroundColor: 'white'
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              margin: '1rem',
	              fontStyle: 'italic',
	              fontSize: 12
	            }
	          },
	          props.applicationText
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: props.applicationFormLink.url,
	            target: '_blank',
	            style: {
	              margin: '1rem 0',
	              border: '3px solid white',
	              padding: '1.5em',
	              textAlign: 'center',
	              color: 'black',
	              fontSize: 18,
	              fontWeight: 600,
	              background: 'white',
	              cursor: 'pointer',
	              display: 'block'
	            },
	            className: 'unselectable card'
	          },
	          props.applicationFormLink.displayName
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          padding: '2rem 2rem 3rem',
	          fontSize: 14,
	          fontWeight: 600,
	          display: 'flex',
	          justifyContent: 'flex-start',
	          alignItems: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.previousStep, style: { cursor: 'pointer' } },
	        _react2.default.createElement(_angleBracket2.default, {
	          color: 'black',
	          style: {
	            width: 5,
	            transform: 'scaleX(-1)',
	            filter: 'FlipH'
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA0\xA0Back'
	        )
	      )
	    )
	  );
	};
	
	var SideContent = function SideContent(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: '#8CBD8C',
	        minHeight: props.height,
	        padding: '15vh ' + ((0, _mediaQueries.isNarrowDesktop)() ? '8vw' : '12.5vw') + ' 1rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '1rem' : '3rem'),
	        width: '42vw'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      { style: { marginBottom: '3rem' } },
	      _react2.default.createElement(_step2.default, props.step)
	    ),
	    _react2.default.createElement(_angleBracketButton2.default, {
	      text: props.eConsortLink.displayName,
	      newTab: true,
	      link: props.eConsortLink.url
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '1rem 0',
	          fontStyle: 'italic',
	          fontSize: 12
	        }
	      },
	      props.registrationText
	    ),
	    _react2.default.createElement(
	      _collapsable2.default,
	      {
	        isCollapsed: true,
	        text: props.registeredButtonText,
	        backgroundColor: 'white'
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            margin: '1rem 0',
	            fontStyle: 'italic',
	            fontSize: 12
	          }
	        },
	        props.applicationText
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          href: props.applicationFormLink.url,
	          target: '_blank',
	          style: {
	            padding: '2em',
	            textAlign: 'center',
	            color: 'black',
	            fontSize: 18,
	            fontWeight: 600,
	            background: 'white',
	            cursor: 'pointer',
	            display: 'block'
	          },
	          className: 'unselectable card'
	        },
	        props.applicationFormLink.displayName
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          fontSize: 14,
	          fontWeight: 600,
	          display: 'flex',
	          justifyContent: 'flex-start',
	          alignItems: 'center',
	          margin: '3rem 0'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.previousStep, style: { cursor: 'pointer' } },
	        _react2.default.createElement(_angleBracket2.default, {
	          color: 'black',
	          style: {
	            width: 5,
	            transform: 'scaleX(-1)',
	            filter: 'FlipH'
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA0\xA0Back'
	        )
	      )
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Fade = __webpack_require__(69);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _mediaQueries = __webpack_require__(8);
	
	var _infoBlock = __webpack_require__(10);
	
	var _infoBlock2 = _interopRequireDefault(_infoBlock);
	
	var _step = __webpack_require__(104);
	
	var _step2 = _interopRequireDefault(_step);
	
	var _angleBracketButton = __webpack_require__(13);
	
	var _angleBracketButton2 = _interopRequireDefault(_angleBracketButton);
	
	var _angleBracket = __webpack_require__(29);
	
	var _angleBracket2 = _interopRequireDefault(_angleBracket);
	
	var _checked = __webpack_require__(278);
	
	var _checked2 = _interopRequireDefault(_checked);
	
	var _unchecked = __webpack_require__(282);
	
	var _unchecked2 = _interopRequireDefault(_unchecked);
	
	var _cross = __webpack_require__(108);
	
	var _cross2 = _interopRequireDefault(_cross);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationRequirements = function (_Component) {
	  _inherits(ApplicationRequirements, _Component);
	
	  function ApplicationRequirements(props) {
	    _classCallCheck(this, ApplicationRequirements);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.getHeight = function () {
	      if (typeof window !== 'undefined') {
	        return window.innerHeight - 56;
	      }
	    };
	
	    _this.toggleConfirm = function (e, req) {
	      e.stopPropagation();
	      e.nativeEvent.stopImmediatePropagation();
	      if (_this.state.confirmedRequirements.hasOwnProperty(req)) {
	        _this.setState(function (prevState) {
	          delete prevState.confirmedRequirements[req];
	          return { confirmedRequirements: prevState.confirmedRequirements };
	        });
	      } else {
	        _this.setState(function (prevState) {
	          var _extends2;
	
	          return {
	            confirmedRequirements: _extends({}, prevState.confirmedRequirements, (_extends2 = {}, _extends2[req] = 1, _extends2))
	          };
	        });
	      }
	    };
	
	    _this.setActiveRequirement = function (req) {
	      return _this.setState({ activeRequirement: req });
	    };
	
	    _this.buttonProps = function (target) {
	      return {
	        style: {
	          border: Object.keys(_this.state.confirmedRequirements).indexOf(target) !== -1 && '3px solid white',
	          background: Object.keys(_this.state.confirmedRequirements).indexOf(target) !== -1 ? 'none' : 'white'
	        },
	        textStyle: {
	          color: Object.keys(_this.state.confirmedRequirements).indexOf(target) !== -1 ? 'white' : 'black'
	        },
	        hasCaret: Object.keys(_this.state.confirmedRequirements).indexOf(target) === -1,
	        hasShadow: Object.keys(_this.state.confirmedRequirements).indexOf(target) === -1
	      };
	    };
	
	    var requirementsCount = props.requirements.length;
	    _this.state = {
	      requirementsCount: requirementsCount,
	      confirmedRequirements: {},
	      activeRequirement: ''
	    };
	    return _this;
	  }
	
	  ApplicationRequirements.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _mediaQueries.Default,
	        null,
	        _react2.default.createElement(DefaultApplicationRequirements, _extends({}, this.props, this.state, {
	          toggleConfirm: this.toggleConfirm,
	          setActiveRequirement: this.setActiveRequirement,
	          getButtonProps: this.buttonProps
	        }))
	      ),
	      _react2.default.createElement(
	        _mediaQueries.Mobile,
	        null,
	        this.state.activeRequirement == null || this.state.activeRequirement.length === 0 ? _react2.default.createElement(MobileApplicationRequirements, _extends({}, this.props, this.state, {
	          toggleConfirm: this.toggleConfirm,
	          setActiveRequirement: this.setActiveRequirement
	        })) : _react2.default.createElement(MobileInfo, _extends({}, this.props, this.state, {
	          toggleConfirm: this.toggleConfirm,
	          setActiveRequirement: this.setActiveRequirement,
	          height: this.getHeight()
	        }))
	      )
	    );
	  };
	
	  return ApplicationRequirements;
	}(_react.Component);
	
	exports.default = ApplicationRequirements;
	
	
	var MobileInfo = function MobileInfo(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: '#8CBD8C',
	        padding: '1rem 2rem',
	        minHeight: props.height
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: 'white',
	          minHeight: props.height - 32,
	          paddingTop: '1rem',
	          overflowY: 'scroll',
	          display: 'grid'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { width: 18, margin: '0 1rem 0 auto' } },
	        _react2.default.createElement(_cross2.default, { color: 'black', onClick: function onClick() {
	            return props.setActiveRequirement('');
	          } })
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            padding: '1rem 2rem'
	          }
	        },
	        props.requirements.map(function (req) {
	          if (req.title === props.activeRequirement) {
	            return _react2.default.createElement(_infoBlock2.default, {
	              title: req.title,
	              extra: req.titleAccent,
	              accentColor: '#8CBD8C',
	              text: req.text.internal.content,
	              key: req.title
	            });
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: '2rem' } },
	          _react2.default.createElement(
	            'span',
	            {
	              style: {
	                display: 'flex',
	                justifyContent: 'flex-start',
	                alignContent: 'center',
	                margin: '0 auto 0 0'
	              }
	            },
	            typeof props.confirmedRequirements[props.activeRequirement] !== 'undefined' ? _react2.default.createElement(_checked2.default, {
	              onClick: function onClick(e) {
	                return props.toggleConfirm(e, props.activeRequirement);
	              }
	            }) : _react2.default.createElement(_unchecked2.default, {
	              onClick: function onClick(e) {
	                return props.toggleConfirm(e, props.activeRequirement);
	              }
	            }),
	            _react2.default.createElement(
	              'span',
	              {
	                onClick: function onClick(e) {
	                  return props.toggleConfirm(e, props.activeRequirement);
	                },
	                className: 'unselectable'
	              },
	              '\xA0Confirm'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: { margin: 'auto auto 1rem 2rem', fontSize: 13 },
	          onClick: function onClick() {
	            return props.setActiveRequirement('');
	          }
	        },
	        'Close'
	      )
	    )
	  );
	};
	
	var MobileApplicationRequirements = function MobileApplicationRequirements(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        background: '#8CBD8C'
	      }
	    },
	    _react2.default.createElement(_infoBlock2.default, {
	      title: props.header.title,
	      bigTitle: true,
	      extra: props.header.titleAccent,
	      accentColor: 'white',
	      text: props.header.text.internal.content,
	      style: { padding: '1rem 2rem' }
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { margin: '0 3rem', paddingBottom: '1rem' } },
	      _react2.default.createElement(_step2.default, props.step)
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { padding: '1rem 2rem' } },
	      props.requirements.map(function (_ref) {
	        var title = _ref.title;
	        return _react2.default.createElement(
	          'div',
	          {
	            style: {
	              background: 'white',
	              padding: '1rem 1.5rem',
	              fontSize: 16,
	              fontWeight: 600,
	              marginBottom: '1rem',
	              display: 'flex',
	              justifyContent: 'space-between'
	            },
	            key: title
	          },
	          _react2.default.createElement(
	            'span',
	            {
	              onClick: function onClick() {
	                if (window) window.scrollTo(0, 0);
	                props.setActiveRequirement(title);
	              }
	            },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { marginLeft: 5 } },
	            typeof props.confirmedRequirements[title] !== 'undefined' ? _react2.default.createElement(_checked2.default, { onClick: function onClick(e) {
	                return props.toggleConfirm(e, title);
	              } }) : _react2.default.createElement(_unchecked2.default, { onClick: function onClick(e) {
	                return props.toggleConfirm(e, title);
	              } })
	          )
	        );
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '0 2rem 2rem',
	          border: '3px solid white',
	          padding: '1.5em',
	          textAlign: 'center',
	          color: Object.keys(props.confirmedRequirements).length === props.requirements.length ? 'black' : 'white',
	          fontSize: 18,
	          fontWeight: 600,
	          background: Object.keys(props.confirmedRequirements).length === props.requirements.length ? 'white' : '#8CBD8C',
	          cursor: Object.keys(props.confirmedRequirements).length === props.requirements.length ? 'pointer' : ''
	        },
	        className: 'unselectable ' + (Object.keys(props.confirmedRequirements).length === props.requirements.length ? 'card' : ''),
	        onClick: function onClick() {
	          if (Object.keys(props.confirmedRequirements).length === props.requirements.length) props.nextStep();
	        }
	      },
	      'Continue'
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          margin: '1rem 3rem',
	          fontStyle: 'italic',
	          fontSize: 12
	        }
	      },
	      props.closingText
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          padding: '2rem 2rem 3rem',
	          fontSize: 14,
	          fontWeight: 600,
	          display: 'flex',
	          justifyContent: 'flex-start',
	          alignItems: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { onClick: props.previousStep, style: { cursor: 'pointer' } },
	        _react2.default.createElement(_angleBracket2.default, {
	          color: 'black',
	          style: {
	            width: 5,
	            transform: 'scaleX(-1)',
	            filter: 'FlipH'
	          }
	        }),
	        _react2.default.createElement(
	          'span',
	          null,
	          '\xA0\xA0Back'
	        )
	      )
	    )
	  );
	};
	
	var DefaultApplicationRequirements = function DefaultApplicationRequirements(props) {
	  return _react2.default.createElement(
	    'div',
	    {
	      style: {
	        display: 'flex'
	      }
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: 'white',
	          minHeight: props.height,
	          padding: (0, _mediaQueries.isTablet)() ? '2rem 4rem 3rem' : '2rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '5rem' : '7rem') + ' 2rem 5rem',
	          width: '58vw'
	        }
	      },
	      _react2.default.createElement(_infoBlock2.default, {
	        title: props.header.title,
	        bigTitle: true,
	        extra: props.header.titleAccent,
	        accentColor: '#8CBD8C',
	        text: props.header.text.internal.content
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            position: 'relative'
	          }
	        },
	        props.requirements.map(function (_ref2) {
	          var title = _ref2.title,
	              text = _ref2.text;
	          return _react2.default.createElement(
	            'div',
	            {
	              key: title,
	              style: {
	                position: 'absolute'
	              }
	            },
	            _react2.default.createElement(
	              _Fade2.default,
	              { when: props.activeRequirement === title, collapse: true },
	              _react2.default.createElement(
	                _infoBlock2.default,
	                {
	                  title: title,
	                  childrenBetween: true,
	                  text: text.internal.content
	                },
	                _react2.default.createElement(
	                  'div',
	                  { style: { marginTop: '1rem' } },
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      style: {
	                        display: 'flex',
	                        justifyContent: 'flex-start',
	                        alignContent: 'center'
	                      }
	                    },
	                    typeof props.confirmedRequirements[title] !== 'undefined' ? _react2.default.createElement(_checked2.default, {
	                      style: {
	                        cursor: 'pointer'
	                      },
	                      onClick: function onClick(e) {
	                        return props.toggleConfirm(e, title);
	                      }
	                    }) : _react2.default.createElement(_unchecked2.default, {
	                      style: {
	                        cursor: 'pointer'
	                      },
	                      onClick: function onClick(e) {
	                        return props.toggleConfirm(e, title);
	                      }
	                    }),
	                    _react2.default.createElement(
	                      'span',
	                      {
	                        style: {
	                          cursor: 'pointer'
	                        },
	                        onClick: function onClick(e) {
	                          return props.toggleConfirm(e, title);
	                        },
	                        className: 'unselectable'
	                      },
	                      '\xA0Confirm'
	                    )
	                  )
	                )
	              )
	            )
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#8CBD8C',
	          minHeight: props.height,
	          padding: '15vh ' + ((0, _mediaQueries.isNarrowDesktop)() ? '8vw' : '12.5vw') + ' 1rem ' + ((0, _mediaQueries.isNarrowDesktop)() ? '1rem' : '3rem'),
	          width: '42vw'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { marginBottom: '3rem' } },
	        _react2.default.createElement(_step2.default, props.step)
	      ),
	      props.requirements.map(function (_ref3, i) {
	        var title = _ref3.title;
	        return _react2.default.createElement(_angleBracketButton2.default, _extends({
	          caretPosition: 'left',
	          caretDirection: 'left',
	          text: title,
	          key: title
	        }, props.getButtonProps(title), {
	          style: _extends({
	            marginBottom: i === props.requirements.length ? Object.keys(props.confirmedRequirements).indexOf(title) !== -1 ? -6 : 0 : i === 0 ? 0 : Object.keys(props.confirmedRequirements).indexOf(title) !== -1 ? ' calc(.5rem - 3px)' : '.5rem',
	            marginTop: i === props.requirements.length ? 0 : i === 0 ? Object.keys(props.confirmedRequirements).indexOf(title) !== -1 ? -6 : 0 : Object.keys(props.confirmedRequirements).indexOf(title) !== -1 ? ' calc(.5rem - 3px)' : '.5rem'
	          }, props.getButtonProps(title).style),
	          onClick: function onClick() {
	            return props.setActiveRequirement(title);
	          }
	        }));
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginTop: '3rem',
	            border: '3px solid white',
	            padding: '1.5em',
	            textAlign: 'center',
	            color: Object.keys(props.confirmedRequirements).length === props.requirementsCount ? 'black' : 'white',
	            fontSize: 18,
	            fontWeight: 600,
	            background: Object.keys(props.confirmedRequirements).length === props.requirementsCount ? 'white' : 'none',
	            cursor: Object.keys(props.confirmedRequirements).length === props.requirementsCount ? 'pointer' : ''
	          },
	          className: 'unselectable ' + (Object.keys(props.confirmedRequirements).length === props.requirementsCount ? 'card' : ''),
	          onClick: function onClick() {
	            if (Object.keys(props.confirmedRequirements).length === props.requirementsCount) props.nextStep();
	          }
	        },
	        'Continue'
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            margin: '2rem 0 3rem',
	            fontStyle: 'italic',
	            fontSize: 12
	          }
	        },
	        props.closingText
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            fontSize: 14,
	            fontWeight: 600,
	            display: 'flex',
	            justifyContent: 'flex-start',
	            alignItems: 'center'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { onClick: props.previousStep, style: { cursor: 'pointer' } },
	          _react2.default.createElement(_angleBracket2.default, {
	            color: 'black',
	            style: {
	              width: 5,
	              transform: 'scaleX(-1)',
	              filter: 'FlipH'
	            }
	          }),
	          _react2.default.createElement(
	            'span',
	            null,
	            '\xA0\xA0Back'
	          )
	        )
	      )
	    )
	  );
	};
	module.exports = exports['default'];

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Step = function Step(_ref) {
	  var current = _ref.current,
	      max = _ref.max,
	      text = _ref.text,
	      style = _ref.style,
	      accent = _ref.accent,
	      _ref$accentColor = _ref.accentColor,
	      accentColor = _ref$accentColor === undefined ? 'white' : _ref$accentColor;
	  return _react2.default.createElement(
	    'div',
	    {
	      style: _extends({}, style)
	    },
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          color: accentColor,
	          fontSize: '20px',
	          fontWeight: 700,
	          marginBottom: '.5rem',
	          display: 'flex',
	          flexDisplay: 'row',
	          alignContent: 'center',
	          justifyContent: 'flex-start'
	        }
	      },
	      current,
	      _react2.default.createElement(
	        'span',
	        { style: { fontSize: '30px', fontWeight: 600 } },
	        '/'
	      ),
	      max
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { fontWeight: 600 } },
	      text,
	      '\xA0',
	      accent && _react2.default.createElement(
	        'span',
	        { style: { color: accentColor } },
	        accent
	      )
	    )
	  );
	};
	
	exports.default = Step;
	module.exports = exports['default'];

/***/ }),

/***/ 278:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Checked = function Checked(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ width: 22.03, height: 22.03 }, props),
	    _react2.default.createElement("image", {
	      "data-name": "Rechthoek 678 kopi\\xEBren 4",
	      width: 22.03,
	      height: 22.03,
	      xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAQ0lEQVQ4jWNkYGD4z0BFwERNw0CABYnNSKFZ/9ENZOjZ20OW90ucS+COobqXRw0cNXDUwOFhIHIBS5Xia5CX2AwMDACGhQkn3Qg5ygAAAABJRU5ErkJggg=="
	    })
	  );
	};
	
	exports.default = Checked;
	module.exports = exports["default"];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _collapsable = __webpack_require__(39);
	
	var _collapsable2 = _interopRequireDefault(_collapsable);
	
	var _MDText = __webpack_require__(25);
	
	var _MDText2 = _interopRequireDefault(_MDText);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var CollapsableCard = function CollapsableCard(_ref) {
	  var title = _ref.title,
	      text = _ref.text,
	      style = _ref.style,
	      backgroundColor = _ref.backgroundColor,
	      children = _ref.children,
	      props = _objectWithoutProperties(_ref, ['title', 'text', 'style', 'backgroundColor', 'children']);
	
	  return _react2.default.createElement(
	    'div',
	    _extends({ style: _extends({ background: backgroundColor }, style) }, props),
	    _react2.default.createElement(
	      _collapsable2.default,
	      {
	        style: { background: backgroundColor, marginBottom: 0 },
	        text: title,
	        isCollapsed: true,
	        hideCardEffects: true
	      },
	      _react2.default.createElement(
	        'div',
	        null,
	        text && _react2.default.createElement(
	          'div',
	          {
	            style: {
	              padding: '1rem 1.5rem',
	              fontSize: '14px'
	            }
	          },
	          _react2.default.createElement(_MDText2.default, { source: text })
	        ),
	        children
	      )
	    )
	  );
	};
	
	exports.default = CollapsableCard;
	module.exports = exports['default'];

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cross = function Cross(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 48.76 48.76" }, props),
	    _react2.default.createElement("path", {
	      d: "M44.76 48.76a4 4 0 0 1-2.83-1.17L24.38 30 6.83 47.59A4 4 0 0 1 4 48.76a4 4 0 0 1-2.83-1.17 4 4 0 0 1 0-5.66l17.55-17.55L1.17 6.83a4 4 0 0 1 5.66-5.66l17.55 17.55L41.93 1.17a4 4 0 1 1 5.66 5.66L30 24.38l17.59 17.55a4 4 0 0 1 0 5.66 4 4 0 0 1-2.83 1.17z",
	      fill: props.color ? props.color : '#fff'
	    })
	  );
	};
	
	exports.default = Cross;
	module.exports = exports["default"];

/***/ }),

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Info = function Info(props) {
	  return _react2.default.createElement(
	    'svg',
	    _extends({ viewBox: '0 0 323 323' }, props),
	    _react2.default.createElement('circle', {
	      cx: 161.5,
	      cy: 161.5,
	      r: 161.5,
	      fill: props.color ? props.color : '#fff'
	    }),
	    _react2.default.createElement('path', { d: 'M161.5 23a138.51 138.51 0 1 1-97.93 40.57A137.58 137.58 0 0 1 161.5 23m0-23A161.5 161.5 0 1 0 323 161.5 161.51 161.51 0 0 0 161.5 0z' }),
	    _react2.default.createElement('path', { d: 'M103.84 107.56A56.62 56.62 0 0 1 127 81.64q15.48-9.12 36.36-9.12 16.8 0 29.88 5.52t20.16 15.24a35.66 35.66 0 0 1 7.08 21.48 39 39 0 0 1-3.36 16.44A53.31 53.31 0 0 1 209 144a163.37 163.37 0 0 1-13 13 166.72 166.72 0 0 0-12.48 12.36 50.06 50.06 0 0 0-7.8 12.12 36 36 0 0 0-3.24 15.36 4.1 4.1 0 0 1-4.08 4.08h-17q-4.32 0-4.32-4.8a55.16 55.16 0 0 1 3.48-20A60.69 60.69 0 0 1 159 160.6a182.22 182.22 0 0 1 13-14.6 113.84 113.84 0 0 0 13-15.36 25 25 0 0 0 4.32-14.16q0-10.08-7.32-16.08t-18.84-6a36.43 36.43 0 0 0-19.68 5.88 32.3 32.3 0 0 0-13.2 15.24 3.39 3.39 0 0 1-1.68 1.8 5.51 5.51 0 0 1-2.64.12l-20.4-5.28q-3.16-1-1.72-4.6zM177 248a5 5 0 0 1-1.32 3.84q-1.32 1.2-4.44 1.2H146.8q-4.56 0-4.56-4.32V222q0-3.84 3.36-3.84h28.32q3.12 0 3.12 3.36z' })
	  );
	};
	
	exports.default = Info;
	module.exports = exports['default'];

/***/ }),

/***/ 282:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Unchecked = function Unchecked(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ width: 22.03, height: 22.03 }, props),
	    _react2.default.createElement("path", {
	      "data-name": "Rechthoek 678 kopi\\xEBren 4",
	      d: "M1.01 1h20.02v20.02H1.01V1z",
	      fill: "none",
	      stroke: "#000",
	      strokeWidth: 2,
	      fillRule: "evenodd"
	    })
	  );
	};
	
	exports.default = Unchecked;
	module.exports = exports["default"];

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.applicationQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _get3 = __webpack_require__(17);
	
	var _get4 = _interopRequireDefault(_get3);
	
	var _applicationChoice = __webpack_require__(261);
	
	var _applicationChoice2 = _interopRequireDefault(_applicationChoice);
	
	var _applicationRequirements = __webpack_require__(264);
	
	var _applicationRequirements2 = _interopRequireDefault(_applicationRequirements);
	
	var _applicationKnowledge = __webpack_require__(262);
	
	var _applicationKnowledge2 = _interopRequireDefault(_applicationKnowledge);
	
	var _applicationProcedure = __webpack_require__(263);
	
	var _applicationProcedure2 = _interopRequireDefault(_applicationProcedure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ApplicationPage = function (_Component) {
	  _inherits(ApplicationPage, _Component);
	
	  function ApplicationPage(props) {
	    _classCallCheck(this, ApplicationPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.nextStep = function () {
	      return _this.setState(function (_ref) {
	        var step = _ref.step;
	        return { step: step + 1 };
	      });
	    };
	
	    _this.previousStep = function () {
	      return _this.setState(function (_ref2) {
	        var step = _ref2.step;
	        return { step: step - 1 };
	      });
	    };
	
	    _this.setChoice = function (choice) {
	      return _this.setState(function (_ref3) {
	        var step = _ref3.step;
	        return { choice: choice, step: step + 1 };
	      });
	    };
	
	    _this.setHeight = function () {
	      var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getWindowHeight();
	      return _this.setState({ height: height });
	    };
	
	    _this.getApplicationChoiceData = function () {
	      var _get = (0, _get4.default)(_this, 'props.data.allContentfulApplicationChoice.edges'),
	          choiceData = _get[0].node;
	
	      var _get2 = (0, _get4.default)(_this, 'props.data.allContentfulProgrammePage.edges'),
	          programmeData = _get2[0].node;
	
	      var _choiceData$programme = _extends({}, choiceData, programmeData),
	          _choiceData$programme2 = _choiceData$programme.header,
	          title = _choiceData$programme2.title,
	          titleAccent = _choiceData$programme2.titleAccent,
	          text = _choiceData$programme2.text.internal.content,
	          tracks = _choiceData$programme.tracks,
	          stepText = _choiceData$programme.step.text,
	          explanationDegrees = _choiceData$programme.explanationDegrees.internal.content,
	          doubleDegreeTitle = _choiceData$programme.doubleDegree,
	          doubleDegreeText = _choiceData$programme.doubleDegreeText.internal.content;
	
	      return {
	        title: title,
	        titleAccent: titleAccent,
	        text: text,
	        tracks: tracks,
	        stepText: stepText,
	        explanationDegrees: explanationDegrees,
	        doubleDegreeTitle: doubleDegreeTitle,
	        doubleDegreeText: doubleDegreeText
	      };
	    };
	
	    _this.getApplicationKnowledgeData = function () {
	      var _get$filter = (0, _get4.default)(_this, 'props.data.allContentfulApplicationKnowledge.edges').filter(function (_ref4) {
	        var node = _ref4.node;
	        return node.track.trackName === _this.state.choice;
	      }),
	          knowledgeData = _get$filter[0].node;
	
	      return knowledgeData;
	    };
	
	    _this.getApplicationRequirementData = function () {
	      var _get$filter2 = (0, _get4.default)(_this, 'props.data.allContentfulApplicationRequirements.edges').filter(function (_ref5) {
	        var node = _ref5.node;
	        return node.track.trackName === _this.state.choice;
	      }),
	          requirementData = _get$filter2[0].node;
	
	      return requirementData;
	    };
	
	    _this.getApplicationProcedureData = function () {
	      var _get$filter3 = (0, _get4.default)(_this, 'props.data.allContentfulApplicationProcedure.edges').filter(function (_ref6) {
	        var node = _ref6.node;
	        return node.track.trackName === _this.state.choice;
	      }),
	          procedureData = _get$filter3[0].node;
	
	      return procedureData;
	    };
	
	    var initialState = {
	      height: getWindowHeight(),
	      step: 1,
	      choice: undefined
	    };
	    var oldState = void 0;
	    if (typeof window !== 'undefined') {
	      oldState = JSON.parse(window.sessionStorage.getItem('applicationState') || '{}');
	      oldState.height = getWindowHeight();
	    }
	    _this.state = typeof oldState !== 'undefined' && oldState.hasOwnProperty('step') && oldState.hasOwnProperty('choice') ? oldState : initialState;
	    return _this;
	  }
	
	  ApplicationPage.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    if (this.state.step !== prevState.step) {
	      if (typeof window !== 'undefined') {
	        window.scrollTo(0, 0);
	      }
	    }
	    if (typeof window !== 'undefined') {
	      window.sessionStorage.setItem('applicationState', JSON.stringify(this.state));
	    }
	  };
	
	  ApplicationPage.prototype.componentDidMount = function componentDidMount() {
	    if (window) {
	      window.addEventListener('resize', this.setHeight);
	    }
	  };
	
	  ApplicationPage.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (window) {
	      window.removeEventListener('resize', this.setHeight);
	    }
	    if (typeof window !== 'undefined') {
	      window.sessionStorage.setItem('applicationState', JSON.stringify(this.state));
	    }
	  };
	
	  ApplicationPage.prototype.render = function render() {
	    var _state = this.state,
	        height = _state.height,
	        step = _state.step;
	
	    var isChoiceStep = step === 1;
	    var isRequirementStep = step === 2;
	    var isKnowledgeStep = step === 3;
	    var isProcedureStep = step === 4;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          fontFamily: "'Libre Franklin', 'sans serif'"
	        }
	      },
	      isChoiceStep && _react2.default.createElement(_applicationChoice2.default, _extends({
	        height: height,
	        setChoice: this.setChoice
	      }, this.getApplicationChoiceData())),
	      isRequirementStep && _react2.default.createElement(_applicationRequirements2.default, _extends({
	        height: height,
	        nextStep: this.nextStep,
	        previousStep: this.previousStep
	      }, this.getApplicationRequirementData())),
	      isKnowledgeStep && _react2.default.createElement(_applicationKnowledge2.default, _extends({
	        height: height,
	        nextStep: this.nextStep,
	        previousStep: this.previousStep
	      }, this.getApplicationKnowledgeData())),
	      isProcedureStep && _react2.default.createElement(_applicationProcedure2.default, _extends({
	        height: height,
	        nextStep: this.nextStep,
	        previousStep: this.previousStep
	      }, this.getApplicationProcedureData()))
	    );
	  };
	
	  return ApplicationPage;
	}(_react.Component);
	
	exports.default = ApplicationPage;
	
	
	var getWindowHeight = function getWindowHeight() {
	  if (typeof window !== 'undefined' && window.hasOwnProperty('innerHeight')) {
	    return window.innerHeight - getHeaderHeight() > 600 ? window.innerHeight - getHeaderHeight() : 600;
	  }
	  return 600;
	};
	var getHeaderHeight = function getHeaderHeight() {
	  if (typeof window !== 'undefined') {
	    if (window.innerWidth < 768) {
	      return 3.5 * 18;
	    } else if (window.innerWidth < 992) {
	      return 3 * 18;
	    } else {
	      return 2.5 * 18;
	    }
	  }
	};
	
	var applicationQuery = exports.applicationQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-application-js-fdc3562ba53432489bb4.js